var BaseViews = require('../base');

require('./page-loading/page-loading.scss');
var PageLoading = BaseViews.LayoutView.extend({
    _menuState: null,
    className: 'fmcy-page-loading',
    template: require('./page-loading/page-loading.html'),
    ui: {
        spinner: '.fmcy-spinner'
    },
    regions: {
        spinnerRegion: '.fmcy-spinner-region'
    },
    showLoader: function() {
        var self = this;

        if (!self.isRendered) {
            return;
        }

        if (self.options.style === 'style1') {
            self._renderSpinnerStyle1();
        }

        window.gsap.to(this.$el,
        {
          opacity: 1,
          duration: 0.5,
          translateY: 0,
          onStart: function () {
            self.$el.removeClass('hide');
          }
        });
    },
    hideLoader: function() {
        var self = this;

        if (!self.isRendered) {
            return;
        }

        window.gsap.to(this.$el,
        {
          opacity: 0,
          duration: 0.5,
          translateY: '+100',
          onComplete: function () {
            if (!self.isRendered) {
                return;
            }
            if (self.options.style === 'style1') {
                self.spinnerRegion.empty();
            }
            self.$el.addClass('hide');
          }
        });
    },
    initialize: function (options) {
        var self = this;
        self.options = _.defaults(
            options || {},
            {
                style: 'style1', // style1
                theme: 'light', // light || dark
            }
        );

        self._menuState = self.model;
        self._menuState.on('change:retrievingPageData', function () {
            self._checkRetrievingPageData();
        });
    },
    _checkRetrievingPageData: function () {
        if (!this.isRendered) {
            return false;
        }

        if (this._menuState.get('retrievingPageData')) {
            this.showLoader();
        } else {
            this.hideLoader();
        }
    },
    onBeforeShow: function() {
        if (this.options.backgroundColor) {
            this.$el.css('background', this.options.backgroundColor);
        }
        if (this.options.theme) {
          this.$el.addClass('page-loading-theme-' + this.options.theme);
        }
    },
    _renderSpinnerStyle1: function () {
        this.spinnerRegion.show(
            new (require('treeline-shared-components/spinner'))({
                message: ''
            })
        );
    },
    onRender: function() {
        this._checkRetrievingPageData();
    }
});

module.exports = PageLoading;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/page-loading.js
 **/